import { MOKA_GOAUTH_SERVICE } from 'api/constants';

export const SHOULD_MOCK = !MOKA_GOAUTH_SERVICE;

export const ALLOWED_BUSINESS_CATEGORY_ID = [
  51, // Retail - Apparel & Accessories
  67, // Retail - Baby
  68, // Retail - Electronics
  69, // Retail - Furniture, Home, & Garden
  70, // Retail - Health & Beauty
  63, // Retail - Other
  71, // Retail - F & B
];

export const ALLOWED_EMAIL = [
  'mindoprod@mailinator.com',
  'hendri.antomy@mokapos.com',
  'mindosormin@mailinator.com',
  'dimass@mailinator.com',
  'product-moka@mailinator.com',
  'hiroo@mailinator.com',
  'ariestafarida@gmail.com',
  'shannonidol@gmail.com',
];

export const ONLINE_STORE_CHANNEL = {
  FACEBOOK: 'FACEBOOK',
  GOOGLE: 'GOOGLE',
};

export const CONNECT_FB_SOURCE = {
  LANDING_PAGE: 1,
  OUTLET_LIST_PAGE: 2,
  CONTINUE_SETUP: 3,
};

export const CONNECT_GOOGLE_SOURCE = {
  LANDING_PAGE: 1,
  OUTLET_LIST_PAGE: 2,
};

export const UI_FLAGS = {
  PRODUCT_SYNCS_COMPLETED_SHOWN: 'product_syncs_completed_shown',
};
